import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@hub-la/design-system';
import CircularProgress from '@mui/material/CircularProgress';
import { Document, pdfjs, Page } from 'react-pdf';

let _ = t => t,
  _t;
const StyledDocument = styled(Document)(_t || (_t = _`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  object-fit: contain;
`));
const Pdf = ({
  url,
  height,
  width
}) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  return jsx(StyledDocument, Object.assign({
    loading: jsx(CircularProgress, {}),
    file: url,
    renderMode: "canvas"
  }, {
    children: jsx(Page, {
      width: width,
      height: height,
      className: "document-pdf-page",
      pageNumber: 1,
      renderAnnotationLayer: false
    }, 'page_1')
  }));
};

export { Pdf };
